// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import classNames from 'classnames';
import React from 'react';

import menuItem from './menu_item';

type Props = {
    ariaLabel?: string;
    id?: string;
    buttonClass?: string;
    content: React.ReactNode;
    'data-testid'?: string;
    onClick?: (e: React.MouseEvent) => void;
}

export const MenuItemActionImpl = ({
    ariaLabel,
    content,
    id,
    buttonClass,
    'data-testid': dataTestId,
    onClick,
}: Props) => (
    <button
        data-testid={dataTestId}
        id={id}
        type='button'
        aria-label={ariaLabel}
        className={classNames('style--none', 'MenuItem__button', buttonClass)}
        onClick={onClick}
    >
        {content}
    </button>
);

const MenuItemAction = menuItem(MenuItemActionImpl);
MenuItemAction.displayName = 'MenuItemAction';

export default MenuItemAction;
